import { useTranslation } from "react-i18next";
import { LineChart } from "./charts/LineChart.js";

function massMaximum(inputData) {
  return inputData.reduce(
    (maxValue, currentValue) => Math.ceil(Math.max(maxValue, currentValue[1])),
    Number.NEGATIVE_INFINITY,
  );
}

function transformDataMassForGraph(inputData) {
  const massData = inputData.map((item) => [
    item._time,
    item.mass / 1000,
    item.image_url,
  ]);
  const max = massMaximum(massData);
  const maxYAxis = max < 12 ? 12 : max + 1;
  return { massData, maxYAxis };
}

function transformDataMassDefaultDensityForGraph(inputData) {
  return inputData.map((item) => [item._time, item.massDefaultDensity / 1000]);
}

function transformDataMassNoPackmatDefaultDensityForGraph(inputData) {
  return inputData.map((item) => [
    item._time,
    item.massNoPackmatDefaultDensity / 1000,
  ]);
}

const ActivityWeightChart = ({ container, historyCycle, findHistoryId }) => {
  const { t } = useTranslation();

  if (!historyCycle?.length) {
    return null;
  }

  const { massData, maxYAxis } = transformDataMassForGraph(historyCycle);

  return (
    <div
      style={{
        marginLeft: "25px",
        marginRight: "25px",
        marginTop: "20px",
        marginBottom: "20px",
      }}
    >
      <LineChart
        chartName="compact"
        dataChart={massData}
        dataChart2={transformDataMassDefaultDensityForGraph(historyCycle)}
        dataChart3={transformDataMassNoPackmatDefaultDensityForGraph(
          historyCycle,
        )}
        unitValueChart="ton"
        maxYAxis={maxYAxis}
        messageLabelTooltip={t("Weight")}
        stepYAxis={2}
        dataForCompactOverlay={historyCycle}
        container={container}
        historyCurrent={historyCycle}
        findHistoryId={findHistoryId}
        showToolbox={false}
        showTitle={false}
      />
    </div>
  );
};

export default ActivityWeightChart;
